import { render, staticRenderFns } from "./AwardNumbers.vue?vue&type=template&id=6b7505c0&"
import script from "./AwardNumbers.vue?vue&type=script&lang=js&"
export * from "./AwardNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports